/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'basic/steering-wheel-1218382': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M12 12a1 1 0 101 1 1 1 0 00-1-1zm9.71-2.36a10 10 0 00-19.4 0 9.75 9.75 0 000 4.72 10 10 0 007.3 7.34 9.67 9.67 0 004.7 0 10 10 0 007.31-7.31 9.75 9.75 0 000-4.72zM12 4a8 8 0 017.41 5H4.59A8 8 0 0112 4zm-8 8a8.26 8.26 0 01.07-1H6v2H4.07A8.26 8.26 0 014 12zm5 7.41A8 8 0 014.59 15H7a2 2 0 012 2zm4 .52a8.26 8.26 0 01-1 .07 8.26 8.26 0 01-1-.07V18h2zm.14-3.93h-2.28A4 4 0 008 13.14V11h8v2.14A4 4 0 0013.14 16zM15 19.41V17a2 2 0 012-2h2.41A8 8 0 0115 19.41zM19.93 13H18v-2h1.93a8.26 8.26 0 01.07 1 8.26 8.26 0 01-.07 1z"/>'
  }
})
